module.exports = __webpack_public_path__ + "static/media/icon_play.2b05d0e3.svg";